import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

/**
 * Resolve refund_id if parameter refund_id value is refund_number (uuid)
 */
const resolveRefundId = getters => {
    let refund_id = getters.receipt.refund_id;

    // is uuid
    if (refund_id && refund_id.length === 36) {
        // find refund_id by uuid
        const refundProduct = getters.receipt.refund_products.find(
            rp => rp.refund && rp.refund.refund_number === refund_id,
        );

        if (refundProduct) {
            refund_id = refundProduct.refund_id;
        }
    }

    return refund_id;
};

const getters = {
    hasTransaction: state => {
        return state.transaction.id !== null;
    },

    hasTable: state => {
        return state.transaction.order.table !== null;
    },

    receipt: state => {
        return state.transaction.receipt;
    },

    isVoided: state => {
        return (
            state.transaction.receipt.voided_at !== null &&
            state.transaction.receipt.voided == true
        );
    },

    table: state => {
        let table = state.transaction.order.table;
        if (table != null) return table.table;
        else return null;
    },

    order: state => {
        return state.transaction.order;
    },

    orderFuel: state => {
        return state.transaction.order.fuel;
    },

    orderTable: state => {
        return state.transaction.order.table;
    },

    /**
     * @return {Array}
     */
    orderProducts: state => {
        return state.transaction.order.products;
    },

    cancelledOrderProducts: (state, getters) => {
        return getters.orderProducts.filter(p => p.cancelled_at);
    },

    purchasedOrderProducts: (state, getters) => {
        return getters.orderProducts.filter(
            p => _.isEmpty(p.modifiers) && !p.cancelled_at,
        );
    },

    purchasedPromotionOrderProducts: (state, getters) => {
        let data = [];

        getters.order.modifiers.map(m => {
            let products = getters.orderProducts
                .filter(
                    orderProduct =>
                        !_.isEmpty(orderProduct.modifiers) &&
                        orderProduct.id === m.product_id &&
                        !orderProduct.cancelled_at,
                )
                .map(product => {
                    product.modifier = null;

                    if (!_.isEmpty(product.modifiers)) {
                        product.modifier = product.modifiers[0];
                    }

                    return product;
                });

            let index = data.findIndex(
                d =>
                    d.promotion_id === m.promotion_id &&
                    (d.promotion_mode === 0 || d.promotion_amount == m.amount),
            );

            if (index !== -1) {
                if (
                    data[index].products.some(
                        product =>
                            product.product_id === m.product.product_id &&
                            product.modifier.mode !== 0,
                    )
                ) {
                    data[index].promotion_quantity += m.quantity;

                    let product_index = data[index].products.findIndex(
                        product => product.product_id === m.product.product_id,
                    );

                    if (product_index !== -1) {
                        data[index].products[product_index].quantity +=
                            m.product.quantity;

                        data[index].products[product_index].amount =
                            parseFloat(
                                data[index].products[product_index].amount,
                            ) + parseFloat(m.product.amount);
                    }
                } else if (
                    data[index].promotion_mode === 0 ||
                    data[index].promotion_amount === m.amount
                ) {
                    data[index].products.push(
                        products.find(
                            product =>
                                product.product_id === m.product.product_id,
                        ),
                    );
                } else {
                    data.push({
                        promotion_id: m.promotion_id,
                        promotion_amount: m.amount,
                        promotion_mode: m.mode,
                        promotion_name: m.name,
                        promotion_quantity: m.quantity,
                        products: products,
                    });
                }
            } else {
                data.push({
                    promotion_id: m.promotion_id,
                    promotion_amount: m.amount,
                    promotion_mode: m.mode,
                    promotion_name: m.name,
                    promotion_quantity: m.quantity,
                    products: products,
                });
            }
        });

        return data;
    },

    transaction: state => {
        return state.transaction;
    },

    outlet: state => {
        return state.transaction.receipt.outlet;
    },

    cashier: state => {
        return state.transaction.receipt.cashier;
    },

    charges: state => {
        return state.transaction.receipt.charges;
    },

    taxes: state => {
        return state.transaction.receipt.taxes;
    },

    voider: (state, getters) => {
        return getters.receipt.voided_staff;
    },

    /**
     * @return {Array}
     */
    discounts: state => {
        let receiptDiscounts = state.transaction.receipt.discounts;

        return receiptDiscounts.map(obj => {
            let name =
                obj.discount == null
                    ? obj.name
                        ? obj.name
                        : obj.remarks
                    : obj.discount.name;

            return {
                name: name,
                amount: obj.amount,
                remarks: obj.remarks,
            };
        });
    },

    fuel: state => {
        return state.transaction.order.fuel;
    },

    payments: state => {
        let receiptPayments = state.transaction.receipt.payments;

        return receiptPayments.map(obj => {
            let reference_number = obj.reference_number;
            let original_approval_code = null;
            let approval_code = null;
            let ref_number = null;
            let stan_no = null;
            let company_name = null;
            let pay_at_forecourt = null;
            let payment_method = null;

            if (!_.isNull(reference_number)) {
                reference_number = reference_number.split('|')[0];
            }

            if (!_.isEmpty(obj.meta)) {
                if (!_.isUndefined(obj.meta.approval_code)) {
                    if (!_.isNull(obj.meta.original_approval_code)) {
                        original_approval_code =
                            obj.meta.original_approval_code;
                    }

                    approval_code = obj.meta.approval_code;
                } else if (!_.isUndefined(obj.meta.b_approval)) {
                    approval_code = obj.meta.b_approval;
                }

                if (!_.isNull(obj.meta.ref)) {
                    ref_number = obj.meta.ref;
                }

                if (!_.isNull(obj.meta.site_tran_no)) {
                    stan_no = obj.meta.site_tran_no;
                }

                if (!_.isNull(obj.meta.company_name)) {
                    company_name = obj.meta.company_name;
                }

                if (obj.meta.pay_at_forecourt) {
                    pay_at_forecourt = obj.meta.pay_at_forecourt;
                }

                if (obj.meta.payment_method) {
                    payment_method = obj.meta.payment_method;
                }
            }

            return {
                name: obj.payment.name,
                amount: obj.amount,
                reference_number: reference_number,
                card: obj.card,
                original_amount: obj.original_amount,
                type: obj.payment.type,
                original_approval_code: original_approval_code,
                approval_code: approval_code,
                ref_number: ref_number,
                stan_no: stan_no,
                company_name: company_name,
                pay_at_forecourt: pay_at_forecourt,
                payment_method: payment_method,
            };
        });
    },

    /**
     * @return {Float}
     */
    totalDiscount: state => {
        let receiptDiscounts = state.transaction.receipt.discounts;
        let totalDiscount = 0;

        receiptDiscounts.forEach(obj => {
            totalDiscount += parseFloat(obj.amount);
        });

        return totalDiscount;
    },

    totalAfterDiscount: (state, getters) => {
        return numeral(
            parseFloat(getters.receipt.amount) + getters.totalDiscount,
        ).format();
    },

    /**
     * @return {Float}
     */
    totalChange: (state, getters) => {
        let totalChange = 0;

        getters.receipt.payments.forEach(p => {
            totalChange += !_.isNull(p.change) ? parseFloat(p.change) : 0;
        });

        return numeral(totalChange - getters.totalFuelChange).format();
    },

    /**
     * @return {Float}
     */
    totalFuelChange: (state, getters) => {
        let totalFuelChange = 0;

        if (
            getters.orderFuel &&
            getters.orderFuel.refund &&
            getters.orderFuel.refund.refund_type !== 'OVERRUN'
        ) {
            totalFuelChange = getters.orderFuel.refund.total_amount;
        }

        return numeral(totalFuelChange).format();
    },

    paymentName: (state, getters) => {
        return getters.payments.map(p => p.name.toLowerCase());
    },

    subTotal: (state, getters) => {
        let receipt = getters.receipt;

        let amount = receipt.amount;

        let refund = receipt.refunds
            .map(f => {
                return parseFloat(f.amount);
            })
            .reduce((a, b) => a + b, 0);

        let subTotal = parseFloat(amount) + parseFloat(refund);

        return subTotal.toFixed(2);
    },

    grandTotal: (state, getters) => {
        let receipt = getters.receipt;

        let amount = receipt.total_amount;

        let refund = receipt.refunds
            .map(f => {
                return parseFloat(f.total_amount);
            })
            .reduce((a, b) => a + b, 0);

        let grandTotal = parseFloat(amount) + parseFloat(refund);

        return grandTotal.toFixed(2);
    },

    returnedOrderProducts: (state, getters) => {
        const refund_id = resolveRefundId(getters);

        return getters.receipt.refund_products
            .filter(f => f.refund_id <= refund_id)
            .map(f => {
                f.product.unit_price = f.amount;
                f.product.quantity = f.quantity;
                f.product.refund = true;
                f.product.refunded_at = f.refund.refunded_at;

                return f.product;
            })
            .sort((a, b) => {
                return moment(b.refunded_at) - moment(a.refunded_at);
            });
    },

    rounding: (state, getters) => {
        let receipt = getters.receipt;

        let receiptRounding = receipt.rounding;

        let refundRounding = receipt.refunds
            .map(f => {
                return parseFloat(f.rounding);
            })
            .reduce((a, b) => a + b, 0);

        let rounding = parseFloat(receiptRounding) + refundRounding;

        return rounding.toFixed(2);
    },

    returnSubTotal: (state, getters) => {
        let receipt = getters.receipt;

        let refund = receipt.refunds.filter(
            f => f.id <= resolveRefundId(getters),
        );

        let amount = refund
            .map(f => {
                return parseFloat(f.amount);
            })
            .reduce((a, b) => a + b, 0);

        return amount.toFixed(2);
    },

    returnGrandTotal: (state, getters) => {
        let receipt = getters.receipt;

        let refund = receipt.refunds.filter(
            f => f.id <= resolveRefundId(getters),
        );

        let total_amount = refund
            .map(f => {
                return parseFloat(f.total_amount);
            })
            .reduce((a, b) => a + b, 0);

        return total_amount.toFixed(2);
    },

    returnRounding: (state, getters) => {
        let receipt = getters.receipt;

        let refund = receipt.refunds.filter(
            f => f.id <= resolveRefundId(getters),
        );

        let rounding = refund
            .map(f => {
                return parseFloat(f.rounding);
            })
            .reduce((a, b) => a + b, 0);

        return rounding.toFixed(2);
    },

    hasLoyalty: (state, getters) => {
        return !_.isEmpty(getters.receipt.loyalty);
    },
};

const state = {
    transaction: {
        id: null,
        receipt: {
            discounts: [],
            payments: [],
            taxes: [],
            refund_id: null,
            voided: false,
        },
        order: {
            products: [],
            table: {
                table: null,
            },
        },
    },
};

const mutations = {
    [type.SET_TRANSACTION](state, transaction) {
        state.transaction = transaction;
    },

    [type.SET_REFUND_ID](state, refund_id) {
        state.transaction.receipt.refund_id = refund_id;
    },

    [type.SET_VOIDED](state, voided) {
        state.transaction.receipt.voided = voided;
    },
};

const actions = {
    getTransaction({ dispatch, commit }, { id, refund_id, voided }) {
        startLoading(dispatch, 'fetch-transaction');

        let url = Laroute.route(
            'franchise.report.transaction.getTransactionReceipt',
            { id: id },
        );

        axios
            .get(url)
            .then(res => {
                endLoading(dispatch, 'fetch-transaction');

                let data = res.data.data;
                commit(type.SET_TRANSACTION, data);

                if (!_.isNull(refund_id)) {
                    commit(type.SET_REFUND_ID, refund_id);
                }

                if (voided) {
                    commit(type.SET_VOIDED, voided);
                }

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-transaction');

                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/transaction.js